import { Suspense, lazy } from 'react'
import { AuthKitProvider } from '@workos-inc/authkit-react'

// Defer heavy widget loading for faster dev startup
const WorkOsWidgets = lazy(() =>
  import('@workos-inc/widgets').then(mod => ({ default: mod.WorkOsWidgets })),
)

const AppAuthProvider = lazy(() =>
  import('@/contexts/app-auth.context').then(mod => ({
    default: mod.AppAuthProvider,
  })),
)

export function Providers({ children }: { children: React.ReactNode }) {
  const clientId = import.meta.env.VITE_WORKOS_CLIENT_ID

  if (!clientId) {
    console.error('VITE_WORKOS_CLIENT_ID is not set')
    return <div>Configuration error: WorkOS client ID not found</div>
  }

  return (
    <AuthKitProvider
      clientId={clientId}
      redirectUri={`${window.location.origin}/auth/callback`}
    >
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <WorkOsWidgets
          theme={{
            accentColor: 'blue',
            grayColor: 'gray',
            radius: 'medium',
            scaling: '100%',
          }}
        >
          <AppAuthProvider>{children}</AppAuthProvider>
        </WorkOsWidgets>
      </Suspense>
    </AuthKitProvider>
  )
}
